import { useState, useEffect } from "react";
import localforage from "localforage";

const useLocalStorage = (key, initialValue) => {
  localforage.config({
    name: 'Relyon',
    isPersistent: true
});
 
  const [value, setValue] = useState();
  useEffect(()=>{
    const getData = async() => {
      localforage.getItem(key).then(item=>{
        if(item){setValue(item)}
        if(initialValue)setValue(initialValue)

    })}
    getData()
  },[])

  const setLocalValue = (value) => {
    try {
      //window.localStorage.setItem(key, JSON.stringify(value));
      localforage?.setItem(key, value)?.then(setValue(value))
      
    } catch (error) {
      alert("Something went wrong with setting localforage, see console");
      console.log(error);   
    }
  }

  return [value, setLocalValue];
}

export default useLocalStorage;

/* const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      if(item){return JSON.parse(item)}
      if(initialValue) return initialValue
      return undefined;
    } catch (error) {
      //alert("Something went wrong.");
      //console.log(`errore ${key} `,error);    
    }
  });

  const setLocalValue = (value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      setValue(value)
    } catch (error) {
      //alert("Something went wrong.");
      //console.log(error);   
    }
  }

  return [value, setLocalValue];
} */
